import OathboundNav from "@/components/OathboundNav/OathboundNav";
import PortalBackLink from "@/components/PortalBackLink";

const DESKTOP_BACKGROUND = "/media/images/desktop_background.jpg";
const MOBILE_BACKGROUND = "/media/images/mobile_background.jpg";

const normalizeParagraphs = (content) => {
  if (Array.isArray(content)) return content;
  return content ? [content] : [];
};

const AuthorPage = ({ authorData }) => {
  const paragraphs = normalizeParagraphs(authorData?.note);

  return (
    <main className="author-page" data-testid="author-page">
      <picture className="portal-background" aria-hidden="true">
        <source media="(min-width: 768px)" srcSet={DESKTOP_BACKGROUND} />
        <img
          src={MOBILE_BACKGROUND}
          alt=""
          width="941"
          height="1672"
          decoding="async"
          fetchpriority="high"
        />
      </picture>
      <div className="author-page-vignette" aria-hidden="true" />

      <OathboundNav />

      <div className="author-page-shell">
        <PortalBackLink />

        <article className="author-page-panel">
          <div className="author-page-copy">
            <p className="author-page-eyebrow">{authorData.eyebrow}</p>
            <h1>{authorData.title}</h1>
            <div className="author-page-note">
              {paragraphs.map((paragraph, index) => (
                <p key={`${index}-${paragraph.slice(0, 24)}`}>{paragraph}</p>
              ))}
            </div>
            <p className="author-page-signature">{authorData.signature}</p>
          </div>

          <div className="author-page-portrait">
            <img
              src={authorData.image}
              alt={authorData.imageAlt}
              width={authorData.imageWidth}
              height={authorData.imageHeight}
            />
          </div>
        </article>
      </div>
    </main>
  );
};

export default AuthorPage;
